import EditVesselDetails from './EditVesselDetails'

export default EditVesselDetails
